<template>
  <div 
    id="modalOrcamento" 
    v-if="mostrar_modal"
    style="display: block; padding-top: 200px; "
    class="w3-modal" 
    v-cloak>

    <div class="w3-modal-content w3-animate-zoom" @click.stop>
      <header class="w3-container">
        <span @click="mostrar_modal = false" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho w3-center">Dados de produtos vendidos</h4>
      </header>

      <div class="w3-col l6 m12">
        <legenda>
          <span>Nome do cliente</span>
          <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
        </legenda>
        <strong data-label="resultado-venda" id="eResultado">{{cliente.cadastro_id}} - {{cliente.nome_fantasia}}</strong>
      </div>
      
      <div class="w3-col l6 m12">
        <legenda>
          <span>Nome do produto</span>
          <i slot="referencia" class="fa fa-shopping-basket texto-vermelho"></i>
        </legenda>
        <strong data-label="resultado-venda" id="eResultado">{{produto.produto_id}} - {{produto.nome_produto}}</strong>
      </div>

      <div class="w3-col s12 m12 l12">
        <label>Marca: </label>
        <strong>{{produto.nome_marca}}</strong>
      </div>

      <div class="w3-col s12 m12 l12">
        <label>Código de barras: </label>
        <strong>{{produto.codigo_barras}}</strong>
      </div>

      <div class="w3-col s12 m12 l12">
        <label>Código original: </label>
        <strong>{{produto.codigo_original}}</strong>
      </div>

      <div class="w3-col s12 m12 l12">  
        <label>Unidade: </label>
        <strong>Unidade: {{produto.unidade}}</strong>
      </div>
    
      <div>
        <div class="w3-bar w3-white w3-border tab" style="border-color:transparent!important;">
          <div class="w3-col s4">
            <button 
              id="botaoVendas" 
              class="w3-bar-item w3-transparent w3-padding-small tablink w3-btn w3-green active" 
              style="width: 100%; cursor:pointer; width: 98%;font-size:80%" 
              v-on:click="trocarAba('botaoVendas', 'tabVendas', true)">
              <i class="fas fa-shopping-cart"></i>
              Vendas
            </button>
          </div>
          
          <div class="w3-col s4">
            <button 
              id="botaoQuantidade"
              class="w3-bar-item w3-transparent w3-padding-small  tablink w3-btn w3-orange w3-text-white" 
              style="width: 100%; cursor:pointer; width: 98%; font-size:80%" 
              v-on:click="trocarAba('botaoQuantidade', 'tabQuantidade', true); 
              criarGrafico('tabQuantidade')">
              <i class="fas fa-luggage-cart"></i>
              Quantidade
            </button>
          </div>
          
          <div class="w3-col s4">
            <button 
              id="botaoValor" 
              class="w3-bar-item w3-transparent w3-padding-small  tablink w3-btn w3-blue" 
              style="width: 100%; cursor:pointer;  width: 98%;font-size:80%" 
              v-on:click="trocarAba('botaoValor', 'tabValor', true); 
              criarGrafico('tabValor')">
              <i class="fas fa-hand-holding-usd"></i>
              Valor
            </button>
          </div>
        </div>       
      </div>

      <dados-orcamento
        :orcamento_dados="orcamento_detalhe"
        v-if="mostrarModalDadosOrcamento"
        @close="mostrarModalDadosOrcamento = false"
      />
      
      <div style="width: 100%" v-if="abaSelecionada == 'tabVendas'">  
        
        <div id="tabVendas" >
          <div class=" w3-center ">
            <h4 class="titulo texto-vermelho">Pedidos</h4>  
          </div>
          
          <div
            v-for="pedido in pedidos" 
            :key="pedido.orcamento_id"
            class=" w3-container card-itens w3-white w3-border w3-margin-top"
            @click="verDetalhesCard(pedido.orcamento_id)" >                       
            <div class="w3-col s12 m12 l12 ">
              <div class="w3-col s12 m12 l12">            
                <label class="texto-vermelho" style="font-size: 15px !important;">
                  <strong> <i class="fa fa-shopping-cart"/> {{pedido.orcamento_id}} ({{pedido.data_recebimento}}) | {{pedido.nome_condicao}}</strong>
                </label>  
              </div> 
              
              <div class="w3-col s12 m12 l12">
                <label style="font-size: 12px;">
                  {{pedido.nome_empresa_resumido}} - {{pedido.nome_vendedor}}
                </label>  
              </div>
              
              <div class="w3-col s12 m12 l4">
                <label>Quantidade: </label> 
                <strong>{{pedido.quantidade}}</strong>                   
              </div>  
              
              <div class="w3-col s12 m12 l4">
                <label>Preço unitário  líquido: </label>
                <strong>R$ {{pedido.preco_venda_liquido}}</strong>
              </div>  
              
              <div class="w3-col s12 m12 l4">
                <label>Total líquido: </label>  
                <strong> R$ {{pedido.preco_total_liquido}}</strong>  
              </div>
              
              <div class="w3-col s12 w3-center" v-show="!pedido.ver_detalhes">
                <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"></i>  
              </div>
            </div>        
                    
            <div class="w3-col" v-show="pedido.ver_detalhes">
              <div class="w3-col s12 m12 l12">
                <div class="w3-col s12 m12 l4">
                  <label>Desc. fechamento: </label>
                  <strong>R$ {{pedido.valor_desconto_proporcional}}</strong>
                </div> 
                <div class="w3-col s12 m12 l4">
                  <label>Preço unitário: </label>
                  <strong>R$ {{pedido.preco_unitario}}</strong>
                </div>      
                <div class="w3-col s12 m12 l4">
                  <label>Total:</label>
                  <strong> R$ {{pedido.preco_total}}</strong>   
                </div>
              </div>
              
              <div 
                class="w3-center"  
                @click="abrirDadosOrcamento(pedido.orcamento_id)">
                <button class="w3-button w3-theme"> 
                <i class="fas fa-search-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div id="tabQuantidade" class="aba" style="height: 100%;" v-if="abaSelecionada == 'tabQuantidade'">
        <VueApexCharts type=line :options="chartOptionsQuantidadeProdutosVendidos" :series="seriesProdutosVendidos"></VueApexCharts>
      </div>
      
      <div id="tabValor" class="aba" style="height: 100%" v-if="abaSelecionada == 'tabValor'">
        <VueApexCharts type=line :options="chartOptionsQuantidadeProdutosVendidos" :series="seriesProdutosVendidos"></VueApexCharts>
      </div>  
    </div> 
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import legenda from '@/components/Legendas'
  import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarDadosProdutosVendidos from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosProdutosVendidos.js'

  export default {
    name: 'DadosProdutosVendidos',
    components: {VueApexCharts, legenda, DadosOrcamento},
    mixins:[formatarValorMixin],
    data() {
      return {
        api: process.env.API,
        mostrar_modal: false,
        pedidos: [],
        produto:{},
        cliente:{},
        proporcao_maxima: 0,
        orcamento_detalhe: undefined,
        mostrarModalDadosOrcamento: false,

        chartOptionsQuantidadeProdutosVendidos: {},
        seriesProdutosVendidos: [],

        /*Aba*/
        abaSelecionada: 'tabVendas'
      }
    },
    watch: {
      mostrar_modal() {
        this.verificarModalAberto()   
      },
    },  
    methods: {
      async exibirModal(produto_id, cliente_id) {
        try {
          let parametros = {
            produto_id: produto_id,
            cliente_id: cliente_id,
          }

          let retorno = await ROrcamentoBuscarDadosProdutosVendidos.buscarDadosProdutosVendidos(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.pedidos = JSON.parse(JSON.stringify(retorno.dados.pedidos));
          this.produto = JSON.parse(JSON.stringify(retorno.dados.produto));
          this.cliente = JSON.parse(JSON.stringify(retorno.dados.cliente));

          for(let i in this.pedidos) {
            this.pedidos[i].ver_detalhes = false
          }

          this.mostrar_modal = true;
        } catch (error) {
          this.verificarErro(error);
        }
      },

      abrirDadosOrcamento(orcamento_id) {
        this.orcamento_detalhe = orcamento_id;
        this.mostrarModalDadosOrcamento = true;
      },

      verificarErro(erro){
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },
      
      stiloModalAtivo(detalhes){
        detalhes? 'background-color: #ececec;' : 'background-color: white;';
      },

      verDetalhesCard(orcamento_id){
        for (let i = 0; i < this.pedidos.length; i++) {
          if (this.pedidos[i].orcamento_id != orcamento_id){
            continue
          }

          this.pedidos[i].ver_detalhes = !this.pedidos[i].ver_detalhes
          break
        }

        this.pedidos = JSON.parse(JSON.stringify(this.pedidos))
      },
      
      verificarModalAberto(){
        const el = document.documentElement;

        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        } 
      },

      trocarAba(botao, novaAba, clicar){       

        let tablinks = document.getElementsByClassName("tablink");
        for (let i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }        
        document.getElementById(botao).className += " active";            
        this.abaSelecionada = novaAba
      },

      criarGrafico(novaAba){    
        var informacao_eixo_y = ''

        let datas =[];
        this.proporcao_maxima = 0;
        
        for (let i = this.pedidos.length - 1; i >= 0; i--){
          datas.push(this.pedidos[i].data_recebimento)

          if(novaAba == 'tabQuantidade'){
            if (this.proporcao_maxima < this.Valor(this.pedidos[i].quantidade)){
              this.proporcao_maxima = this.Valor(this.pedidos[i].quantidade)
            }
          }
          else if(novaAba == 'tabValor'){
            if (this.proporcao_maxima < this.Valor(this.pedidos[i].preco_total_liquido)){
              this.proporcao_maxima = this.Valor(this.pedidos[i].preco_total_liquido)
            }
          }
        }

        if(novaAba == 'tabValor'){
          informacao_eixo_y = 'Total líquido'
        } 
        else{
          informacao_eixo_y = 'Quantidade'
        } 

        this.chartOptionsQuantidadeProdutosVendidos = {
          chart: {
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#77B6EA', '#545454'],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: undefined,
            align: 'left'
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], 
              opacity: 0.5
            },
          },
          markers: {
            size: 5,
            shape: 'circle',
          },
          xaxis: {
            categories: datas,
            title: {
              text: 'Data do recebimento'
            }
          },
          yaxis: {
            title: {
              text: informacao_eixo_y
            },
            min: 0,
            max: this.proporcao_maxima
          },
          legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }, 
          dataLabels: {
            formatter: function(val){
              return val
            }
          }
        }

        let dados_linhas_produtos_vendidos = []          

        if(novaAba == 'tabQuantidade'){
          /*Quantidade*/
          let quantidade_vendida = {
            name: 'Quantidade',
            data: []
          };   

          for (let i = this.pedidos.length - 1; i >= 0; i--){
            quantidade_vendida.data.push(this.Valor(this.pedidos[i].quantidade))
          }
          
          dados_linhas_produtos_vendidos.push(quantidade_vendida)
        }

        if(novaAba == 'tabValor'){
          /*Total líquido*/
          let total_liquido = {
            name:'Total líquido',
            data : []
          };           

          for (let i = this.pedidos.length - 1; i >= 0; i--){
            total_liquido.data.push(this.Valor(this.pedidos[i].preco_total_liquido))
          }
          
          dados_linhas_produtos_vendidos.push(total_liquido)
        }

        /*SEMPRE POR ÚLTIMO*/
        //Series são os dados do eixo Y do gráfico
        this.seriesProdutosVendidos = dados_linhas_produtos_vendidos      
      },
    },
    computed: {
      verificarModal() {
        if (
          this.abrir_modal
        ) return true
        else return false     
      }
    }
  }
</script>

<style scoped>
  .card-produto{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }
  .card-produto.active{
    background: #ebebeb;
  }
 
  .card-produto *{
    cursor:pointer !important;
  }

  .tab-active.active{
    background-color: #8d1007 !important;
    color: #fff !important;
  }

  .tab{
    border-style: solid none solid solid !important;
  }

  .tab > div{
    border-right: 1px solid transparent!important
  }

</style>



// WEBPACK FOOTER //
// src/components/Orcamentos/DadosProdutosVendidos.vue